// extracted by mini-css-extract-plugin
module.exports = {"more-input-data-form":"more-input-data-form-71fb7a47e9e08ceafd79d8a0a079dab2"};